// CustomAlert.jsx
import React from 'react';
import Modal from 'react-modal';
import './styles.css';

const CustomAlert = ({ isOpen, onClose, message }) => {
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="Alert"
            className="custom-modal"
            overlayClassName="custom-overlay"
        >
            <div className="alert-container">
                <h2 className="alert-title">Athugasemd</h2>
                <p className="alert-message">{message}</p>
                <button onClick={onClose} className="alert-button">Loka</button>
            </div>
        </Modal>
    );
};

export default CustomAlert;
